import { baseUrl } from "../const/base-url";

export type Option = { _id: string; name: string; price: number | string };

export async function fetchOptionById(id?: string | null) {
  if (!id) return null;
  const res = await fetch(`${baseUrl}/api/options`);
  if (!res.ok) throw new Error("Не удалось загрузить опции");
  const all: any[] = await res.json();

  const toId = (x: any) =>
    typeof x === "string"
      ? x
      : typeof x?.$oid === "string"
      ? x.$oid
      : typeof x?.toHexString === "function"
      ? x.toHexString()
      : String(x);

  const found = all.find((o) => toId(o._id) === String(id));
  return found
    ? {
        _id: toId(found._id),
        name: found.name,
        price: Number(found.price ?? 0),
      }
    : null;
}

export async function fetchOptions(): Promise<Option[]> {
  const res = await fetch(`${baseUrl}/api/options`);
  if (!res.ok) throw new Error("Не удалось загрузить опции");
  return res.json();
}

const toId = (x: any): string => {
  if (!x) return "";
  if (typeof x === "string") return x.trim();
  if (typeof x?.$oid === "string") return x.$oid.trim();
  if (typeof x?.toHexString === "function") return x.toHexString();
  if (typeof x?.toString === "function") return x.toString();
  return String(x).trim();
};

export async function fetchOptionsByIds(ids: string[]): Promise<Option[]> {
  const clean = (ids || []).map((s) => String(s).trim()).filter(Boolean);
  if (clean.length === 0) return [];

  const all = await fetchOptions();
  const set = new Set(clean);
  return all.filter((o) => set.has(toId(o._id)));
}
